"use strict";

var Dropzone = require("./..\\..\\..\\..\\bower_components\\dropzone\\dist\\min\\dropzone.min.js");

module.exports = function () {

	Dropzone.options.myAwesomeDropzone = {

		paramName : "data",
		autoProcessQueue : false,
		uploadMultiple : false,
		parallelUploads : 1,
		maxFiles : 1,
		acceptedFiles : ".json",
		maxFilesize : 50,

		dictDefaultMessage : "Поместите сюда файл для загрузки",
		dictFallbackMessage : "Ваш браузер не поддерживает загрузку файлов перетаскиванием. Нажмите сюда",
		dictInvalidFileType : "Файл не подходит. Загружаемый файл должен иметь расширение .json",
		dictFileTooBig : "Загружен слишком большой файл. Максимальный размер файла — 50 мегабайт",

		// Dropzone settings
		init : function () {
			var myDropzone = this;

			this.element.querySelector("button[type=submit]").addEventListener("click", function (e) {
				e.preventDefault();
				e.stopPropagation();
				myDropzone.processQueue();
			});
			this.on("success", function (file, response) {

				this
					.removeFile(file)
					.disable();

				$('#my-awesome-dropzone').remove();
				Dropzone.options.myAwesomeDropzone = false;

				var captionMassage = 'Данные успешно загружены и обрабатываются',
					captionClass = 'dropzone-caption',
					captionClassInner = captionClass + '__inner';

				if (response.status != 'success') {
					captionClassInner += ' ' + captionClassInner + '_error';
					captionMassage = 'В процессе обновления данных произошла ошибка.'
				}

				$('.' + captionClass).html('<span class="' + captionClassInner + '">' + captionMassage + '</span>');
			});

		}

	};

	$('#my-awesome-dropzone').dropzone();

};